import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { toast } from 'react-toastify';
import { ColorRing } from 'react-loader-spinner';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import { Button, Row, Col, FormInput } from "shards-react";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ common }) => ({ getDoc: common.getDoc, updateDoc: common.updateDoc }))
@observer
class BlogConfig extends Component {

  @observable isLoading = true;
  @observable teamUser = {};
  @observable store = {};

  @observable settings = {
    pageAddress: '',
    perPage: 10,
    maxWidth: 1080,
    marginTop: 0,
    marginBottom: 0,
    marginX: 0
  };

  componentDidMount() {
    this.init();
  }

  @action init = async () => {
    if (this.props.isLogin) {
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.props.getDoc('getBlogSettings', {
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo || 1
      }, (res) => {
        if (res && res.data) {
          const d = res.data;
          this.settings = {
            pageAddress: d.pageAddress || '',
            perPage: typeof d.perPage === 'number' ? d.perPage : 10,
            maxWidth: typeof d.maxWidth === 'number' ? d.maxWidth : 1080,
            marginTop: typeof d.marginTop === 'number' ? d.marginTop : 0,
            marginBottom: typeof d.marginBottom === 'number' ? d.marginBottom : 0,
            marginX: typeof d.marginX === 'number' ? d.marginX : 0
          };
        }
        this.isLoading = false;
      });
    }
  };

  @action onChangeNum = (key, value) => {
    const n = parseInt(value);
    this.settings[key] = isNaN(n) ? 0 : n;
  };

  @action saveSettings = () => {
    this.props.updateDoc('updateBlogSettings', {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo || 1,
      pageAddress: this.settings.pageAddress,
      perPage: this.settings.perPage,
      maxWidth: this.settings.maxWidth,
      marginTop: this.settings.marginTop,
      marginBottom: this.settings.marginBottom,
      marginX: this.settings.marginX
    }, (res, errors) => {
      if (errors && errors.length > 0) {
        toast.error((errors[0] && errors[0].message) || '저장에 실패했습니다.');
      } else {
        toast.success('블로그 설정이 저장되었습니다.');
      }
    });
  };

  render() {
    if (this.isLoading) {
      return (
        <div className="text-center" style={{paddingTop: '100px'}}>
          <ColorRing visible={true} height="60" width="60" colors={['#5a6169','#5a6169','#5a6169','#5a6169','#5a6169']}/>
        </div>
      );
    }
    const s = this.settings;
    const labelStyle = {fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block'};
    const subLabel = {fontSize: 12, fontWeight: 500, color: '#6B7280', marginBottom: 6, display: 'block'};

    return (
      <div className="main-content">
        <PageTitle />
        <div className="widget-box">
          <div className="section-box">
            <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, padding: '16px 20px', borderBottom: '1px solid #F1F5F9'}}>
              <div style={{flex: 1}}>
                <h3 style={{margin: 0, fontSize: 15, fontWeight: 700, color: '#1F2937'}}>블로그 설정</h3>
                <p style={{margin: '6px 0 0', fontSize: 13, color: '#6B7280', lineHeight: 1.5}}>
                  쇼핑몰에 노출되는 블로그 페이지의 주소와 레이아웃(페이지당 글 수, 최대 너비, 여백)을 설정합니다.
                </p>
              </div>
              <Button theme="primary" onClick={this.saveSettings} style={{flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 4}}>
                <FeatherIcon icon="save" size="14"/> 저장
              </Button>
            </div>
            <div style={{padding: '16px 20px'}}>
              <Row>
                <Col md="12" style={{marginBottom: 16}}>
                  <label style={labelStyle}>블로그 페이지 주소</label>
                  <FormInput value={s.pageAddress} placeholder="예: /blog 또는 https://쇼핑몰주소/blog"
                             onChange={e => this.settings.pageAddress = e.target.value}/>
                </Col>
                <Col md="6" style={{marginBottom: 16}}>
                  <label style={labelStyle}>페이지당 블로그 수</label>
                  <FormInput type="number" min="1" value={s.perPage} onChange={e => this.onChangeNum('perPage', e.target.value)}/>
                </Col>
                <Col md="6" style={{marginBottom: 16}}>
                  <label style={labelStyle}>블로그 최대 너비 (px)</label>
                  <FormInput type="number" min="0" value={s.maxWidth} onChange={e => this.onChangeNum('maxWidth', e.target.value)}/>
                </Col>
              </Row>

              <label style={labelStyle}>여백 (px)</label>
              <Row>
                <Col md="4" style={{marginBottom: 16}}>
                  <label style={subLabel}>상단</label>
                  <FormInput type="number" min="0" value={s.marginTop} onChange={e => this.onChangeNum('marginTop', e.target.value)}/>
                </Col>
                <Col md="4" style={{marginBottom: 16}}>
                  <label style={subLabel}>하단</label>
                  <FormInput type="number" min="0" value={s.marginBottom} onChange={e => this.onChangeNum('marginBottom', e.target.value)}/>
                </Col>
                <Col md="4" style={{marginBottom: 16}}>
                  <label style={subLabel}>좌우</label>
                  <FormInput type="number" min="0" value={s.marginX} onChange={e => this.onChangeNum('marginX', e.target.value)}/>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlogConfig;
